<template>
  <v-app-bar color="black" class="elevation-1">
    <v-row justify="center" align="center">
      <!-- Left -->
      <v-col md="4" align="center" class="white--text text-caption"
        >Demo Store</v-col
      >

      <!-- Middle -->
      <v-col md="4" align="center">
        <router-link to="/">
          <v-img
            src="@/assets/boodil-logo.png"
            max-width="150"
            position="center center"
            contain
          ></v-img>
        </router-link>
      </v-col>

      <!-- Right -->
      <v-col md="4" align="center">
        <router-link v-if="cartItems" to="/cart">
          <v-badge :content="quantity" overlap left color="#2dc59a">
            <v-icon color="white">mdi-cart</v-icon>
          </v-badge>
        </router-link>

        <v-icon v-else color="white">mdi-cart</v-icon>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    quantity: Number,
  },

  computed: {
    cartItems() {
      if (this.$route.name == "Confirmation" || this.$route.name == "Payload") {
        return false;
      }
      else {
        return true;
      }
    },
  },

  data() {
    return {};
  },
};
</script>

<style>
</style>